import { useEffect, useState } from "react";
import emailjs from "emailjs-com";


const initialState = {
  name: "",
  email: "",
  message: "",
};


export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState(null);
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (showPopup) {
      setTimeout(() => setShowPopup(false), 5000);
    }
  }, [showPopup]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSending(true)
    console.log(name, email, message);

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    // 1. Send notification to site owner
    emailjs
      .sendForm(
        serviceId,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        publicKey
      )
      .then(
        (result) => {
          setError(null);
          setShowPopup(true)
          console.log("Owner notification sent:", result.text);
          clearState();
          setIsSending(false);
        },
        (err) => {
          console.log("Owner notification error:", err.text);
          setError(err.message);
          setShowPopup(true)
          setIsSending(false);
        }
      );

    // 2. Send auto-reply to the person who submitted
    emailjs
      .sendForm(
        serviceId,
        process.env.REACT_APP_EMAILJS_AUTOREPLY_TEMPLATE_ID,
        e.target,
        publicKey
      )
      .then(
        (result) => {
          console.log("Auto-reply sent:", result.text);
          clearState();
        },
        (error) => {
          console.log("Auto-reply error:", error.text);
        }
      );
  };
  return (
    <div>
      <section id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Lépj kapcsolatba velem</h2>
                <p>
                  Kérjük, töltse ki az alábbi űrlapot, hogy küldjön nekünk egy
                  e-mailt, és mi a lehető leghamarabb válaszolunk Önnek. Ha
                  sürgős üzenetet szeretne küldeni, kérjük, hívjon minket a
                  megadott telefonszámon.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Név"
                        aria-label="Név"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        aria-label="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Üzenet"
                    aria-label="Üzenet"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" disabled={isSending} className="btn btn-custom btn-lg">
                  Elküldés
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Kontakt Infó</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Cím
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Telefon
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <span>
                <i className="fa fa-facebook"></i> Facebook
              </span>{" "}
              <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noreferrer" style={{ color: "white" }}>
                https://www.facebook.com/p/Ga%C3%A1l-Garage-Aut%C3%B3szervi
              </a>
            </div>
          </div>
        </div>
      </section>
      <footer id="footer">
        <div className="container text-center d-flex">
          <p>
            &copy; 2026 Gaal Garage. Design by{" "}
            <a href="http://www.templatewire.com" rel="nofollow">
              TemplateWire
            </a>
          </p>
          <div style={{display: "flex", justifyContent: "center", gap: "2rem"}}>
            <a href="/adatkezeles?page=adatvedelem">
              Adatvédelmi Nyilatkozat
            </a>
            <a href="/adatkezeles?page=impresszum">
              Impresszum
            </a>
          </div>
        </div>
      </footer>

      { /* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            bottom: "32px",
            left: "50%",
            transform: "translateX(-50%)",
            background: error ? "#d32f2f" : "#2e7d32",
            color: "#fff",
            padding: "14px 24px",
            borderRadius: "8px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            gap: "16px",
            zIndex: 9999,
            fontSize: "15px",
            minWidth: "280px",
            animation: "slideUp 0.3s ease",
          }}
        >
          <span>{error || "Email sikeresen elküldve!"}</span>
          <button
            onClick={() => setShowPopup(false)}
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              fontSize: "18px",
              cursor: "pointer",
              lineHeight: 1,
              marginLeft: "auto",
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};
